import { Injectable } from '@angular/core';
import { AttendancePrescriptionOccurrencesInput } from '@libs/types/src/services/input-type/attendance/attendance-prescription-occurrences.input';
import { GridInput } from '@it2go/data-grid';
import { OkObject } from '@it2go/types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import {
    AttendancePrescriptionCreateInput,
} from '@libs/types/src/services/input-type/attendance/attendance-prescription.create-input';
import {
    AttendancePrescriptionPatchInput,
} from '@libs/types/src/services/input-type/attendance/attendance-prescription.patch-input';
import {
    AttendancePrescriptionObject,
    AttendancePrescriptionObjectGrid,
} from '@libs/types/src/services/object-type/attendance/attendance-prescription.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { filterFrag } from './types/filter.types';
import {
    AttendancePrescriptionCandidatesInput,
} from '@libs/types/src/services/input-type/attendance/attendance-prescription-candidates.input';
import {
    AttendancePrescriptionCandidateObject,
} from '@libs/types/src/services/object-type/attendance/attendance-prescription-candidate.object';

@Injectable({ providedIn: 'root' })
export class AttendancePrescriptionGqlService extends GqlServiceV2 {

    public getAttendancePrescriptionOccurrences(input: AttendancePrescriptionOccurrencesInput, fragment: string) {
        return this.query<AttendancePrescriptionCandidateObject[]>(`
            query($input: AttendancePrescriptionOccurrencesInput!) {
                attendancePrescription {
                    occurrences(input: $input) {
                        ${fragment}
                    }
                }
            }
        `, { input });
    }

    public getAttendancePrescriptions(input: GridInput, fragment: string) {
        return this.query<AttendancePrescriptionObjectGrid>(`
            query($input: GridInput!) {
                attendancePrescription {
                    filter(input: $input) {
                        ${filterFrag}
                        items {
                            ${fragment}
                        }
                    }
                }
            }
        `, { input });
    }

    public createAttendancePrescription(input: AttendancePrescriptionCreateInput, fragment: string) {
        return this.mutate<AttendancePrescriptionObject>(`
            mutation($input: AttendancePrescriptionCreateInput!) {
                attendancePrescription {
                    create(input: $input) {
                        ${fragment}
                    }
                }
            }
        `, { input });
    }

    public patchAttendancePrescription(input: AttendancePrescriptionPatchInput, fragment: string) {
        return this.mutate<AttendancePrescriptionObject>(`
            mutation($input: AttendancePrescriptionPatchInput!) {
                attendancePrescription {
                    patch(input: $input) {
                        ${fragment}
                    }
                }
            }
        `, { input });
    }

    public deleteAttendancePrescription(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(`
            mutation($input: IdInput!) {
                attendancePrescription {
                    delete(input: $input) {
                        ${fragment}
                    }
                }
            }
        `, { input });
    }

    public getAttendancePrescriptionCandidates(
        input: AttendancePrescriptionCandidatesInput,
        fragment: string,
    ) {
        return this.query<AttendancePrescriptionCandidateObject[]>(`
            query($input: AttendancePrescriptionCandidatesInput!) {
                attendancePrescription {
                    candidates(input: $input) {
                        ${fragment}
                    }
                }
            }
        `, { input });
    }

}
